import React from 'react'
import { sh, ReduxWrapper, compose } from 'common-data/datahelpers'
import { DataGrid } from 'common-controls/Core/DataGrid'
import _ from 'common-tools/LodashHelper'

export const LayoutContentPageMap = compose(
  ReduxWrapper([
    sh.SessionAccount,
    sh.SessionUser
  ])
)(function LayoutContentPageMapPlain (props) {
  const { data, className, renderDataItem, SessionAccount, SessionUser } = props

  function renderItem (a, i, l) {
    if (_.isFunction(renderDataItem) === false) {
      return
    }

    if (_.isArray(a.permissions) === true) {
      let hasPerm = SessionAccount.HasPermissions(a.permissions) || SessionUser.HasPermissions(a.permissions)
      if (hasPerm === false) {
        return
      }
    } else if (_.isString(a.permissions)) {
      let hasPerm = SessionAccount.HasPermissions([a.permissions]) || SessionUser.HasPermissions([a.permissions])
      if (hasPerm === false) {
        return
      }
    }

    return renderDataItem(a, i, l)
  }

  return (
    <div className={className}>
      <DataGrid data={data || []} renderDataItem={renderItem} />
    </div>
  )
})

export default LayoutContentPageMap
